/**
 * @description: 路由
 * @author: nowThen
 */

import Vue from 'vue';
import Router from 'vue-router';

const Error = () => import(/* webpackChunkName: "error" */ '@/views/error/index');
// const Layout = () => import(/* webpackChunkName: "apply" */ '@/views/layout/layout')
const LayoutBlank = () => import(/* webpackChunkName: "apply" */ '@/views/layout/layoutBlank')

Vue.use(Router);

const routes = [
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: {
      title: '404页'
    }
  },
  // {
  //   path: '/draw',
  //   name: 'draw',
  //   component: () => import('@/views/exam/paper/components/draw.vue'),
  //   meta: {
  //     title: '绘图'
  //   }
  // },
  {
    path: '*',
    redirect: 'error',
  },
  {
    path: '/',
    redirect: { name: 'examLogin' }
  },
  {
    path: '/education',
    component: LayoutBlank,
    children: [
      {
        path: 'login',
        component: () => import('@/views/education/login'),
        name: 'educationLogin',
        meta: {
          title: '测评登录', // 标题
          requireAuth: false, // 登录权限
        }
      }
    ]
  },
  // {
  //   path: '/education/exam',
  //   component: () => import('@/views/education/exam/layout'),
  //   name: 'exam',
  //   meta: {
  //     title: '测评开始', // 标题
  //     requireAuth: false, // 登录权限
  //   },
  //   children: [
  //     {
  //       path: 'video',
  //       component: () => import('@/views/education/exam/video'),
  //       name: 'educationVideo',
  //       meta: {
  //         title: '视频测评', // 标题
  //         requireAuth: false, // 登录权限
  //       }
  //     },
  //     // {
  //     //   path: 'darg',
  //     //   component: () => import('@/views/education/exam/darg'),
  //     //   name: 'educationDarg',
  //     //   meta: {
  //     //     title: '拖拽测评', // 标题
  //     //     requireAuth: false, // 登录权限
  //     //   }
  //     // },
  //     {
  //       path: 'record',
  //       component: () => import('@/views/education/exam/record'),
  //       name: 'educationRecord',
  //       meta: {
  //         title: '录音测评', // 标题
  //         requireAuth: false, // 登录权限
  //       }
  //     },
  //     {
  //       path: 'darwing',
  //       component: () => import('@/views/education/exam/darwing'),
  //       name: 'educationDarwing',
  //       meta: {
  //         title: '画板测评', // 标题
  //         requireAuth: false, // 登录权限
  //       }
  //     }
  //   ]
  // },
  {
    path: '/exam',
    component: LayoutBlank,
    children: [
      {
        path: 'login',
        component: () => import('@/views/exam/login'),
        name: 'examLogin',
        meta: {
          title: '测评登录', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'paper',
        component: () => import('@/views/education/exam/layout'),
        meta: {
          title: '试题', // 标题
          requireAuth: false, // 登录权限
        },
        children: [
          {
            path: 'innovation',
            component: () => import('@/views/exam/paper/steer/innovation'),
            name: 'examInnovationSteer',
            meta: {
              title: '创新引导试题', // 标题
              requireAuth: false, // 登录权限
              stats: false,
              innovation: true, // 标记创新题
            }
          },
          {
            path: 'criticism',
            component: () => import('@/views/exam/paper/steer/criticism'),
            name: 'examCriticismSteer',
            meta: {
              title: '批判引导试题', // 标题
              requireAuth: false, // 登录权限
              stats: false, // 不需要统计
              criticism: true
            }
          },
          {
            path: 'controller',
            component: () => import('@/views/exam/paper/controller/task1_1'),
            name: 'examController',
            meta: {
              title: '控制器试题-创新C', // 标题
              requireAuth: false, // 登录权限
              innovation: true
            }
          },
          {
            path: 'pepper',
            component: () => import('@/views/exam/paper/pepper'),
            name: 'examPepper',
            meta: {
              title: '辣椒试题-批判B', // 标题
              requireAuth: false, // 登录权限
              criticism: true // 标记批判题
            }
          },
          {
            path: 'stormwater',
            component: () => import('@/views/exam/paper/stormwater/index2'),
            name: 'examStormwater',
            meta: {
              title: '雨水试题-创新D', // 标题
              requireAuth: false, // 登录权限
              innovation: true,
            }
          },
          {
            path: 'cosmodom',
            component: () => import('@/views/exam/paper/cosmodom'),
            name: 'examCosmodom',
            meta: {
              title: '太空站实验室试题-创新A', // 标题
              requireAuth: false, // 登录权限
              innovation: true,
            }
          },
          {
            path: 'birdFlu',
            component: () => import('@/views/exam/paper/bird-flu'),
            name: 'examBirdFlu',
            meta: {
              title: '禽流感-创新B', // 标题
              requireAuth: false, // 登录权限
              innovation: true,
            }
          },
          {
            path: 'sprout',
            component: () => import('@/views/exam/paper/sprout'),
            name: 'examSprout',
            meta: {
              title: '发豆芽-创新E', // 标题
              requireAuth: false, // 登录权限
              innovation: true,
            }
          },
          {
            path: 'phone',
            component: () => import('@/views/exam/paper/phone'),
            name: 'examPhone',
            meta: {
              title: '手机的使用-批判A', // 标题
              requireAuth: false, // 登录权限
              criticism: true
            }
          },
          {
            path: 'duJiangYan',
            component: () => import('@/views/exam/paper/du-jiang-yan'),
            name: 'examDuJiangYan',
            meta: {
              title: '都江堰的历史和发展-批判C', // 标题
              requireAuth: false, // 登录权限
              criticism: true
            }
          },
          {
            path: 'chiliProblem',
            component: () => import('@/views/exam/paper/chili-problem'),
            name: 'examChiliProblem',
            meta: {
              title: '辣椒的问题-批判D', // 标题
              requireAuth: false, // 登录权限
              criticism: true
            }
          },
          {
            path: 'energy',
            component: () => import('@/views/exam/paper/energy'),
            name: 'examEnergy',
            meta: {
              title: '能源问题-批判E', // 标题
              requireAuth: false, // 登录权限
              criticism: true
            }
          },
        ]
      }
    ]
  },
  {
    path: '/questionnaire',
    // component: () => import('@/views/exam/questionnaire/index'),
    // name: 'questionnaire',
    meta: {
      title: '人格调查', // 标题
      requireAuth: false, // 登录权限
    },
    component: LayoutBlank,
    redirect: { name: 'questionnaireStudent' },
    children: [
      {
        path: 'questionCriticism',
        component: () => import('@/views/exam/questionnaire/criticismQuestion'),
        name: 'questionCriticism',
        meta: {
          title: '批判题问卷调查', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'elementaryInnovation',
        component: () => import('@/views/exam/questionnaire/elementaryInnovation'),
        name: 'elementaryInnovation',
        meta: {
          title: '小学-创新题问卷调查', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'juniorInnovation',
        component: () => import('@/views/exam/questionnaire/juniorInnovation'),
        name: 'juniorInnovation',
        meta: {
          title: '初中-创新题问卷调查', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'student',
        component: () => import('@/views/exam/questionnaire/student'),
        name: 'questionnaireStudent',
        meta: {
          title: '学生人格调查', // 标题
          requireAuth: false, // 登录权限
        }
      },
      {
        path: 'teacher',
        component: () => import('@/views/exam/questionnaire/teacher'),
        name: 'questionnaireTeacher',
        meta: {
          title: '老师人格调查', // 标题
          requireAuth: false, // 登录权限
        }
      }
    ]
  }
];

const router = new Router({
  mode: 'history',
  routes
})

export default router;
